import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";

// const timerSeconds = 300;
// let tid = new Object();

const getDefaultState = () => {
  return {
    Toast: {
      isOpen: false,
      contents: "",
    },
    Modal: {
      isOpen: false,
      contents: "",
    },
    MotpCertnFn: {
      succFn: "",
      failFn: "",
      bizDscd: "",
    },

    SSInfogetMotp: {
      in: {},
      out: [
        // {
        // 	strUserId: "G21000009100000"
        // , secret: "dfefewfsdfadsafasdfasdfsdf...."
        // }
      ],
    },
    /**
     * 예금계좌상세조회
     */
    RBF0404B40: {
      acnoSelect: {
        acno: "",
        acnoDetail: {
          acnKnd: "",
          bal: 0,
          cnpr: 0,
          ctrcTrmCnt: 0,
          expirYmd: "",
          lnBal: 0,
          newYmd: "",
          ovsesCustOcntryName: "",
          totalExtenCnt: 0,
          wwwBnkgJoinAbilYn: "",
        },
      },
      in: {
        acno: "",
        brncoEcrypPwd: "",
        acnDsticCd: "",
      },
      out: {},
    },
    /**
     * 고객정보조회
     */
    RBF0409E40: {
      in: {},
      out: {
        success: {
          orderedCphnNoGrid: [
            // {
            // 	"cphnNo": "01022225555",
            // 	"recvCnsntYn": "1",
            // 	"maktngRecvCnsntYn": "0",
            // 	"sendYMS": "20210901111112"
            // }
          ],
          orderedEmailGrid: [
            // {
            // 	"email": "besthaek@gmail.com",
            // 	"recvCnsntYn": "0",
            // 	"maktngRecvCnsntYn": "0",
            // 	"sendYMS": "00000000000000"
            // }
          ],
        },
        fail: {},
      },
    },
    /**
     * 인증코드 입력 남은 시간
     */
    sendTime: 0,
    /**
     * 인증코드(sms/email) 요청
     */
    sendCetrNo: {
      messageForTimeOut: false,
      in: {
        msgSendPtrnCd: "", // 1:SMS, 2:EMAIL
        cphnNo: "",
        emailAddr: "",
      },
      out: {
        success: { certnNoSerno: "", certnNo: "" },
        fail: {},
      },
    },

    /**
     * 인증코드(sms/email) 확인
     */
    sendCetrNoConfirm: {
      in: {
        certnNoSerno: "",
        certnNo: "",
      },
      out: {
        success: { certnNoCnfrmRsultDstcd: "" },
        fail: {},
      },
    },
    /**
     * mPIN 번호의 보안유효성 검사
     */
    checkMpin: {
      vue: {
        mpin01: "",
        mpin02: "",
        mpin03: "",
        mpin04: "",
        mpin05: "",
        mpin06: "",
      },
      in: {
        mPin01: "",
        mPin02: "",
      },
      out: {
        success: {
          rsultCd: "",
          equalResult: "",
        },
        fail: {},
      },
    },
    /**
     * mOTP 등록
     */
    SSRegisterMotpPin: {
      in: {
        result: "",
        publickey: "",
        userdata: "",
        errorcode: "",
        smphMchtlUniqNo: "", // 스마트폰기기고유번호
        smphMchtlDstcd: "", // 스마트폰기기구분코드(1:IPhone, 2:안드로이드)
        pgmVsnno: "", // 프로그램버전번호
        smphMdelName: "", // 스마트폰모델명
      },
      out: {
        success: {
          RESULT: "",
          MOTPINFO: "",
          SKEY: "",
          ERRORCODE: "",
        },
        fail: {},
      },
    },
    /**
     * mOTP 인증
     */
    CertMotpPin: {
      in: {
        userid: "",
        motpnumber: "",
        // id: "",
        // userpw: "",
      },
      out: {
        success: {
          RESULT: "",
          USERID: "",
          SID: "",
          ERRORCODE: "",
        },
        fail: {},
      },
    },
    /**
     * mOTP 발급 init
     */
    initMotp: {
      in: {
        pinProcess: "", //1.pin새로변경, 2.pin분실변경
      },
      out: {
        success: {
          mOtpId: "",
          systemId: "",
          wwwBnkgLginID: "",
          otpStusDstcd: "",
          issuncYMS: "",
          SmphMchtlUniqNo: "",
          lastCertnSucssYMS: "",
          totalCertnErrNotms: "",
          certnErrNotms: "",
        },
        fail: {},
      },
    },
    /**
     * mOTPID
     */
    certnMotpId: {
      in: {},
      out: {
        success: {
          mOtpId: "",
          systemId: "",
          wwwBnkgLginID: "",
          otpStusDstcd: "",
          issuncYMS: "",
          SmphMchtlUniqNo: "",
          lastCertnSucssYMS: "",
          totalCertnErrNotms: "",
          certnErrNotms: "",
        },
        fail: {},
      },
    },
    /**
     * mOTP 발급완료
     */
    finishMotp: {
      in: {
        result: "",
        secret: "",
        errorcode: "",
      },
      out: {
        success: {
          dailyTrsaccClam: "", // 일일이체한도
          casPerTrsaccClam: "", // 건별이체한도금액
          certnDmndCd: "", // 인증요청코드(1:자동, 2:수동)
        },
        fail: {},
      },
    },

    /**
     * APP 인증코드 콜백데이터
     */
    SSGenerateMotp: {
      result: "", // 결과코드
      motp: "", // mOTP난수
      errorcode: "", // 에러코드
      failcount: "", // mPin 오류횟수
    },
    updateMpinErr: {
      in: {
        iD: "",
      },
      out: {
        success: {},
        fail: {},
      },
    },
  };
};

const changeMotpPin = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getToast: state => {
      return state.Toast;
    },
    getSSInfogetMotp: state => {
      return state.SSInfogetMotp;
    },
    getRBF0404B40: state => {
      return state.RBF0404B40;
    },
    getRBF0409E40: state => {
      return state.RBF0409E40;
    },
    getSendCetrNo: state => {
      return state.sendCetrNo;
    },
    getCheckOtp: state => {
      return state.checkOtp;
    },
    getSendCetrNoConfirm: state => {
      return state.sendCetrNoConfirm;
    },
    getCheckMpin: state => {
      return state.checkMpin;
    },
    getSSGenerateMotp: state => {
      return state.SSGenerateMotp;
    },
    getInitMotp: state => {
      return state.initMotp;
    },
    getCertnMotpId: state => {
      return state.certnMotpId;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    // mut001: function(state, payload) {
    //   this._vm.$set(state.SSInfogetMotp, "out", payload);
    // },
    mut001: function(state, payload) {
      state.SSInfogetMotp.out = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotp.out.push(e);
        });
    },
    mut002: function(state, payload) {
      this._vm.$set(state.RBF0404B40.in, payload.key, payload.value);
    },
    mut003: function(state, payload) {
      this._vm.$set(state.sendCetrNo.in, payload.key, payload.value);
    },
    mut004: function(state, payload) {
      this._vm.$set(state.sendCetrNoConfirm.in, payload.key, payload.value);
    },
    mut007: function(state, payload) {
      this._vm.$set(state.checkMpin.in, payload.key, payload.value);
    },
    mut008: function(state, payload) {
      this._vm.$set(state.SSRegisterMotpPin.in, payload.key, payload.value);
    },
    mut009: function(state, payload) {
      this._vm.$set(state.finishMotp.in, payload.key, payload.value);
    },
    mut010: function(state, payload) {
      this._vm.$set(state.Modal, payload.key, payload.value);
    },
    mut013: function(state, payload) {
      this._vm.$set(state.SSGenerateMotp, payload.key, payload.value);
    },
    mut014: function(state, payload) {
      this._vm.$set(state.MotpCertnFn, payload.key, payload.value);
    },
    mut015: function(state, payload) {
      this._vm.$set(state.certnMotpId, payload.key, payload.value);
    },
  },
  actions: {
    /**
     * 예금계좌 상세조회
     */
    act001: function() {
      return new Promise(resolve => {
        // 계좌번호
        this.state.auth.changeMotpPin.RBF0404B40.in.acno = this.state.auth.changeMotpPin.RBF0404B40.acnoSelect.acno.split(";")[0];
        // 계좌구분코드
        this.state.auth.changeMotpPin.RBF0404B40.in.acnDsticCd = this.state.auth.changeMotpPin.RBF0404B40.acnoSelect.acnoDetail.acnKnd;

        this._vm.$post(
          "/auth/motp/pinnomgt/RBF0404B40",
          this.state.auth.changeMotpPin.RBF0404B40.in,
          response => {
            this.state.auth.changeMotpPin.RBF0404B40.out = response;
            resolve("success");
          },
          response => {
            this.state.auth.changeMotpPin.RBF0404B40.out = response;
            resolve("fail");
          },
        );
      });
    },

    /**
     * 발송초기화
     */
    act006: function() {
      this.state.auth.changeMotpPin.sendCetrNo.messageForTimeOut = false;
      this.state.auth.changeMotpPin.sendCetrNoConfirm.in.certnNoSerno = "";
      this.state.auth.changeMotpPin.sendCetrNoConfirm.in.certnNo = "";
    },

    /**
     * mPIN 번호의 보안유효성 && 동일성 검사
     */
    act009: function(context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/pinnomgt/checkMpin",
          this.state.auth.changeMotpPin.checkMpin.in,
          response => {
            // 첫번째 입력. 성공
            if (this.state.auth.changeMotpPin.checkMpin.in.mPin01 !== "" && this.state.auth.changeMotpPin.checkMpin.in.mPin02 === "") {
              this.state.auth.changeMotpPin.checkMpin.vue.mpin01 = "";
              this.state.auth.changeMotpPin.checkMpin.vue.mpin02 = "";
              this.state.auth.changeMotpPin.checkMpin.vue.mpin03 = "";
              this.state.auth.changeMotpPin.checkMpin.vue.mpin04 = "";
              this.state.auth.changeMotpPin.checkMpin.vue.mpin05 = "";
              this.state.auth.changeMotpPin.checkMpin.vue.mpin06 = "";
              // console.log("mPIN1 키패드---->", this.state.auth.changeMotpPin.checkMpin.in.mPin01);
              // [native] keypad 2번째 입력한다.
              context.dispatch("act010", "openKeypadForMotpReg2_pinNoMgt");
            }

            // 두번째 입력. 성공.
            if (this.state.auth.changeMotpPin.checkMpin.in.mPin01 !== "" && this.state.auth.changeMotpPin.checkMpin.in.mPin02 !== "") {
              // console.log("mPIN2 키패드---->", this.state.auth.changeMotpPin.checkMpin.in.mPin02);
              // [native] SSRegisterMotpPin 호출!!
              context.dispatch("act010", "SSRegisterMotpPin_pinNoMgt");
            }

            this._vm.$set(this.state.auth.changeMotpPin.checkMpin.out, "success", response);
            resolve("success");
          },
          response => {
            this.state.auth.changeMotpPin.checkMpin.vue.mpin01 = "";
            this.state.auth.changeMotpPin.checkMpin.vue.mpin02 = "";
            this.state.auth.changeMotpPin.checkMpin.vue.mpin03 = "";
            this.state.auth.changeMotpPin.checkMpin.vue.mpin04 = "";
            this.state.auth.changeMotpPin.checkMpin.vue.mpin05 = "";
            this.state.auth.changeMotpPin.checkMpin.vue.mpin06 = "";

            // 첫번째 입력. 실패
            if (this.state.auth.changeMotpPin.checkMpin.in.mPin01 !== "" && this.state.auth.changeMotpPin.checkMpin.in.mPin02 === "") {
              context.commit("mut007", { key: "mPin01", value: "" });
            }

            // 두번째 입력. 실패
            if (this.state.auth.changeMotpPin.checkMpin.in.mPin01 !== "" && this.state.auth.changeMotpPin.checkMpin.in.mPin02 !== "") {
              context.commit("mut007", { key: "mPin02", value: "" });
            }

            // error modal open
            // context.commit("mut010", { key: "isOpen", value: true });
            // context.commit("mut010", { key: "contents", value: response.TreatDesc });

            this._vm.$set(this.state.auth.changeMotpPin.checkMpin.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * native bridge call
     */
    act010: function(context, payload) {
      switch (payload) {
        case "openKeypadForMotpReg2_pinNoMgt":
          this._vm.$bridge.openKeypadForMotpReg2_pinNoMgt();
          break;
        case "SSRegisterMotpPin_pinNoMgt":
          // console.log("mOtpId------>", this.state.auth.changeMotpPin.initMotp.out.success.mOtpId);
          // console.log("systemId------>", this.state.auth.changeMotpPin.initMotp.out.success.systemId);
          this._vm.$bridge.SSRegisterMotpPin_pinNoMgt(this.state.auth.changeMotpPin.initMotp.out.success.mOtpId, this.state.auth.changeMotpPin.initMotp.out.success.systemId);
          break;
        case "SSInitializeMotp_pinNoMgt":
          this._vm.$bridge.SSInitializeMotp_pinNoMgt({
            strUserId: this.state.auth.changeMotpPin.initMotp.out.success.mOtpId,
            strSystemId: this.state.auth.changeMotpPin.initMotp.out.success.systemId,
            strMotpInfo: this.state.auth.changeMotpPin.SSRegisterMotpPin.out.success.MOTPINFO,
            strSKey: this.state.auth.changeMotpPin.SSRegisterMotpPin.out.success.SKEY,
          });
          break;
      }
    },

    /**
     * mOTP 등록
     */
    act011: function(context) {
      return new Promise(resolve => {
        this.state.auth.changeMotpPin.SSRegisterMotpPin.in.smphMchtlUniqNo = this.state.native.smphMchtlUniqNo;
        this.state.auth.changeMotpPin.SSRegisterMotpPin.in.smphMchtlDstcd = this._vm.$bridge.isIos() ? "1" : this._vm.$bridge.isAndroid() ? "2" : "";
        this.state.auth.changeMotpPin.SSRegisterMotpPin.in.pgmVsnno = this.state.native.pgmVsnno;
        this.state.auth.changeMotpPin.SSRegisterMotpPin.in.smphMdelName = this.state.native.smphMdelName;

        this._vm.$post(
          "/auth/motp/pinnomgt/SSRegisterMotpPin",
          this.state.auth.changeMotpPin.SSRegisterMotpPin.in,
          response => {
            // [native] SSInitializeMotp 호출!!
            this._vm.$set(this.state.auth.changeMotpPin.SSRegisterMotpPin.out, "success", response);
            context.dispatch("act010", "SSInitializeMotp_pinNoMgt");
            resolve("success");
          },
          response => {
            // error modal open
            context.commit("mut010", { key: "isOpen", value: true });
            context.commit("mut010", { key: "contents", value: response.TreatDesc });
            this._vm.$set(this.state.auth.changeMotpPin.SSRegisterMotpPin.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * mOTP pin관리  init
     */
    act012: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/pinnomgt/initMotp",
          this.state.auth.changeMotpPin.initMotp.in,
          response => {
            this._vm.$set(this.state.auth.changeMotpPin.initMotp.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.changeMotpPin.initMotp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * mOTP 발급완료 - native 정상완료인 경우만 호출함.
     */
    act013: function() {
      this._vm.$log.info("mOTP pin관리 발급완료!!");
      router.push({ name: "changeMotpPinStep5" });

      // return new Promise(resolve => {
      //   this._vm.$post(
      //     "/auth/motp/issunc/finishMotp",
      //     this.state.auth.createMotp.finishMotp.in,
      //     response => {
      //       this._vm.$log.info("mOTP 발급완료!!");
      //       router.push({ name: "createMotpStep10" });
      //       this._vm.$set(this.state.auth.createMotp.finishMotp.out, "success", response);
      //       resolve("success");
      //     },
      //     response => {
      //       // error modal open
      //       context.commit("mut010", { key: "isOpen", value: true });
      //       context.commit("mut010", { key: "contents", value: response.TreatDesc });
      //       this._vm.$set(this.state.auth.createMotp.finishMotp.out, "fail", response);

      //       // MCI거래 에러시..메인으로..중간 데이터 변경이 필요할수도 있으므로..

      //       resolve("fail");
      //     },
      //   );
      // });
    },

    /**
     * 발급시 기기정보 후 처리
     */
    act014: function() {
      // console.log("pin관리 init nav smphMchtlUniqNo---------->" + this.state.native.smphMchtlUniqNo);
      // console.log("pin관리 init db mOtpId---------->" + this.state.auth.changeMotpPin.initMotp.out.success.mOtpId);
      // console.log("pin관리 init ssinfo strUserId------>", this.state.auth.changeMotpPin.SSInfogetMotp.out);
      // console.log("pin관리 init db otpStusDstcd------>", this.state.auth.changeMotpPin.initMotp.out.success.otpStusDstcd);
      // console.log("pin관리 init db systemId------>", this.state.auth.changeMotpPin.initMotp.out.success.systemId);
      // console.log("pin관리 init db SmphMchtlUniqNo------>", this.state.auth.changeMotpPin.initMotp.out.success.SmphMchtlUniqNo);

      // 030 이용등록 - mOTP (재)발급 상태(mOTP가 정상인 경우).
      // 120 사고신고 - mOTP 사고신고 상태(고객 및 myStarG에서 mOTP 사고 신고한 경우).
      // 130 폐기 - mOTP 폐기상태(mOTP를 폐기한 경우).
      // 131 이용해지 - mOTP 이용해지상태(mOTP 발급 후 tokenOTP 발급된 경우).
      // 140 (인증번호)오류횟수초과 - mOTP 인증번호6자리를 5회이상 잘못입력한 경우.
      // 150 mpin오류횟수초과 - mOTP pin번호 6자리를 5회이상 잘못입력한 경우.

      // 현재 폰에 정상인 mOTP가 있는 경우.
      if (
        this.state.auth.changeMotpPin.SSInfogetMotp.out.filter(item => {
          return item.strUserId === this.state.auth.changeMotpPin.initMotp.out.success.mOtpId;
        }).length > 0 &&
        (this.state.auth.changeMotpPin.initMotp.out.success.otpStusDstcd === "030" ||
          this.state.auth.changeMotpPin.initMotp.out.success.otpStusDstcd === "140" ||
          this.state.auth.changeMotpPin.initMotp.out.success.otpStusDstcd === "150") &&
        this.state.auth.changeMotpPin.initMotp.out.success.SmphMchtlUniqNo === this.state.native.smphMchtlUniqNo
      ) {
        // console.log("OK---->현재 폰에 정상인 mOTP가 있는 경우 030,140,150");
        if (this.state.auth.changeMotpPin.initMotp.out.success.otpStusDstcd === "150" || this.state.auth.changeMotpPin.initMotp.out.success.otpStusDstcd === "140") {
          router.push({ name: "changeMotpPinStep2-1" });
        }
      } else {
        // console.log("NO---->현재 폰에 비정상인 mOTP가 있는 경우, 기기고유번호 다름");
        router.push({ name: "changeMotpPinStep9" });
      }
    },

    /**
     * mOTP PC인증 app 호출 성공시..
     * 실패횟수가 4회 이하인 경우 - 인증번호 팝업을 열고, 타이머 초기화..
     * 실패횟수가 5회 이상인 경우 - mOTP상태코드 변경.
     */
    act015: function(context) {
      // this.state.auth.authPCMotp.sendTime = timerSeconds;
      // clearInterval(tid);
      // console.log("pin번호 실패횟수가-------->" + this.state.auth.changeMotpPin.SSGenerateMotp.failcount);

      if (Number(this.state.auth.changeMotpPin.SSGenerateMotp.failcount) === 5) {
        // this.state.auth.authPCMotp.AuthModal.isOpen = false;
        context.dispatch("act017");
      }
    },

    /**
     * Mopt 서버인증 실행
     */
    act016: function() {
      return new Promise(resolve => {
        this.state.auth.changeMotpPin.CertMotpPin.in.userid = this.state.auth.changeMotpPin.certnMotpId.out.success.mOtpId;
        this.state.auth.changeMotpPin.CertMotpPin.in.motpnumber = this.state.auth.changeMotpPin.SSGenerateMotp.motp;
        // console.log("bizDscd-------->" + this.state.auth.changeMotpPin.MotpCertnFn.bizDscd);
        this._vm.$post(
          "/auth/motp/" + this.state.auth.changeMotpPin.MotpCertnFn.bizDscd + "/CheckOTPLogin",
          this.state.auth.changeMotpPin.CertMotpPin.in,
          response => {
            this.state.auth.changeMotpPin.MotpCertnFn.succFn();
            // console.log("motp인증 success >>> ", response);
            resolve(response);
          },
          response => {
            // console.log("motp인증 fail >>> ", response);
            this.state.auth.changeMotpPin.MotpCertnFn.failFn();
            resolve(response);
          },
        );
      });
    },
    /**
     * mPin오류누적(5회) 데이터 업데이트
     */
    act017: function() {
      return new Promise(resolve => {
        // console.log("mPin오류누적(5회) 데이터 업데이트-------->");
        this.state.auth.changeMotpPin.updateMpinErr.in.iD = this.state.auth.changeMotpPin.certnMotpId.out.success.mOtpId;

        this._vm.$post(
          "/auth/motp/pinnomgt/updateMpinErr",
          this.state.auth.changeMotpPin.updateMpinErr.in,
          response => {
            router.push({ name: "changeMotpPinStep1" }); //pin번호 관리
            this._vm.$set(this.state.auth.changeMotpPin.updateMpinErr.out, "success", response);
            resolve("success");
          },
          response => {
            // context.commit("mut010", { key: "isOpen", value: true });
            // context.commit("mut010", { key: "contents", value: response.TreatDesc });
            this._vm.$set(this.state.auth.changeMotpPin.updateMpinErr.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * mOTPID
     */
    act018: function() {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/pinnomgt/motpId",
          this.state.auth.changeMotpPin.certnMotpId.in,
          response => {
            this._vm.$set(this.state.auth.changeMotpPin.certnMotpId.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.changeMotpPin.certnMotpId.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },

    /**
     * pin 프로세스
     */
    act019: function() {
      return new Promise(resolve => {
        // console.log("initMotp-------->", this.state.auth.changeMotpPin.initMotp.in);
        this._vm.$post(
          "/auth/motp/pinnomgt/initProcess",
          this.state.auth.changeMotpPin.initMotp.in,
          response => {
            this._vm.$set(this.state.auth.changeMotpPin.initMotp.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.changeMotpPin.initMotp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },

    /**
     * 발급시 기기정보 후 처리
     */
    act020: function() {
      // console.log("motp 인증 nav smphMchtlUniqNo---------->" + this.state.native.smphMchtlUniqNo);
      // console.log("motp 인증 db mOtpId---------->" + this.state.auth.changeMotpPin.certnMotpId.out.success.mOtpId);
      // console.log("motp 인증 ssinfo strUserId------>", this.state.auth.changeMotpPin.SSInfogetMotp.out);
      // console.log("motp 인증 db otpStusDstcd------>", this.state.auth.changeMotpPin.certnMotpId.out.success.otpStusDstcd);
      // console.log("motp 인증 db systemId------>", this.state.auth.changeMotpPin.certnMotpId.out.success.systemId);
      // console.log("motp 인증 db SmphMchtlUniqNo------>", this.state.auth.changeMotpPin.certnMotpId.out.success.SmphMchtlUniqNo);

      // 030 이용등록 - mOTP (재)발급 상태(mOTP가 정상인 경우).
      // 120 사고신고 - mOTP 사고신고 상태(고객 및 myStarG에서 mOTP 사고 신고한 경우).
      // 130 폐기 - mOTP 폐기상태(mOTP를 폐기한 경우).
      // 131 이용해지 - mOTP 이용해지상태(mOTP 발급 후 tokenOTP 발급된 경우).
      // 140 (인증번호)오류횟수초과 - mOTP 인증번호6자리를 5회이상 잘못입력한 경우.
      // 150 mpin오류횟수초과 - mOTP pin번호 6자리를 5회이상 잘못입력한 경우.

      // 현재 폰에 정상인 mOTP가 있는 경우.
      if (
        this.state.auth.changeMotpPin.SSInfogetMotp.out.filter(item => {
          return item.strUserId === this.state.auth.changeMotpPin.certnMotpId.out.success.mOtpId;
        }).length > 0 &&
        (this.state.auth.changeMotpPin.certnMotpId.out.success.otpStusDstcd === "030" ||
          this.state.auth.changeMotpPin.certnMotpId.out.success.otpStusDstcd === "140" ||
          this.state.auth.changeMotpPin.certnMotpId.out.success.otpStusDstcd === "150") &&
        this.state.auth.changeMotpPin.certnMotpId.out.success.SmphMchtlUniqNo === this.state.native.smphMchtlUniqNo
      ) {
        // console.log("motp 인증 OK---->현재 폰에 정상인 mOTP가 있는 경우 030,140,150");
      } else {
        // console.log("motp 인증 NO---->현재 폰에 비정상인인 경우, motpID, 기기고유번호 다름");
        router.push({ name: "changeMotpPinStep9" });
      }
    },

    /**
     * mPin 등록시 2번째 키패드 이전버튼 클릭시.. 일단 mPin등록 처음부터..
     */
    act021: function(context) {
      context.commit("mut007", { key: "mPin01", value: "" });
      context.commit("mut007", { key: "mPin02", value: "" });
    },
  },
};

export default changeMotpPin;

/**
 	ErrmsgErrcd: "",
	OutptLangDstcd: "",
	CustGuidLinkURL: "",
	ErrmsgErrSituNo: "",
	CustGuidLinkURLCtnt: "",
	ErrmsgTreatCd: "",
	Clear: "",
	ErrmsgErrPgmName: "",
	Type: "",
	TreatDesc: "",
	Trancode: "",
	ErrmsgOutptCstzMsgCtnt: "",
	MapngDstcd: "",
	Subtype: ""
 */
